var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { authActions } from 'src/redux/auth/authActions';
import { KeycloakEntity } from '../KeycloakEntity';
import { isLocalRun } from '../constants';
import store from '../store';
import { saveInLocalStorage } from 'src/shared/helpers/storageHelpers';
export var useInitKeycloak = function (realm) {
    var _a = useState(false), isAuth = _a[0], setIsAuth = _a[1];
    var _b = useState(false), isInit = _b[0], setIsInit = _b[1];
    // Init keycloak and redirect to keycloak page if not logged
    useEffect(function () {
        setIsInit(function () { return false; });
        if (realm) {
            KeycloakEntity.init({
                url: window.env.API_KEYCLOAK,
                realm: realm,
                clientId: 'middle-office',
            })
                .then(function (authenticated) { return __awaiter(void 0, void 0, void 0, function () {
                var kc, userInfo;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!authenticated) return [3 /*break*/, 2];
                            kc = KeycloakEntity.kc;
                            return [4 /*yield*/, kc.loadUserInfo()];
                        case 1:
                            userInfo = (_a.sent()) //onMount need to call loadUserInfo instead of read .userInfo
                            ;
                            store.dispatch(authActions.loginSucceeded({
                                accessToken: kc.token,
                                refreshToken: kc.refreshToken,
                                userInfo: userInfo,
                            }));
                            setIsAuth(true);
                            return [3 /*break*/, 3];
                        case 2:
                            saveInLocalStorage({ streamRunning: [] });
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (err) { return console.log('error', err); })
                .finally(function () {
                setIsInit(function () { return true; });
            });
        }
    }, [realm]);
    // Ask to refresh token all 5 seconds if necessary
    useEffect(function () {
        if (!isLocalRun && realm) {
            var TIME_BEFORE_REQUEST_TO_REFRESH = 5000;
            var intervalToRefresh_1;
            intervalToRefresh_1 = setInterval(function () {
                KeycloakEntity.refreshToken()
                    .then(function (refreshed) {
                    if (refreshed) {
                        var kc = KeycloakEntity.kc;
                        var userInfo = KeycloakEntity.kc.userInfo;
                        store.dispatch(authActions.loginSucceeded({
                            accessToken: kc.token,
                            refreshToken: kc.refreshToken,
                            userInfo: userInfo,
                        }));
                        setIsAuth(true);
                    }
                })
                    .catch(function () { return clearInterval(intervalToRefresh_1); });
            }, TIME_BEFORE_REQUEST_TO_REFRESH);
            return function () { return clearInterval(intervalToRefresh_1); };
        }
    }, [realm]);
    return { isAuth: isAuth, isInit: isInit };
};
